import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { Typography } from '@mui/material';
import React, { memo } from 'react';
import { useDrag } from 'react-dnd';

import { GetPitchbookCompanyRawDealsResponse } from '~/services/rtkQuery/company/types';

export const DRAGGABLE_TABLE_ROW = 'DRAGGABLE_TABLE_ROW';

interface Props {
  rawDeal: GetPitchbookCompanyRawDealsResponse['result']['data'][number];
  roundName?: string;
}

const Component: React.FC<Props> = ({ rawDeal, roundName }) => {
  const [{ isDragging }, drag] = useDrag({
    type: DRAGGABLE_TABLE_ROW,
    item: () => {
      return { rawDeal, roundName };
    },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return drag(
    <tr style={isDragging ? { opacity: 0 } : undefined} title="Move">
      <td>
        <div>
          <DragIndicatorIcon
            sx={{
              width: '16px',
              height: '16px',
              color: 'var(--gray-6-color)',
              display: 'none',
              mr: '1px',
            }}
          />
          <Typography color="text.primary" fontWeight="500" variant="body1">
            {rawDeal.dealno}
          </Typography>
        </div>
      </td>
      <td>
        <Typography color="text.primary" fontWeight="500" variant="body1">
          {rawDeal.seriesofstock}
        </Typography>
      </td>
      <td>
        <Typography color="text.primary" fontWeight="500" variant="body1">
          {rawDeal.dealdate}
        </Typography>
      </td>
      <td>
        <Typography color="text.primary" fontWeight="500" variant="body1">
          {rawDeal.announceddate}
        </Typography>
      </td>
      <td>
        <Typography color="text.primary" fontWeight="500" variant="body1">
          {rawDeal.dealsize?.toFixed(2)}
        </Typography>
      </td>
      <td>
        <Typography color="text.primary" fontWeight="500" variant="body1">
          {rawDeal.premoneyvaluation?.toFixed(2)}
        </Typography>
      </td>
      <td>
        <Typography color="text.primary" fontWeight="500" variant="body1">
          {rawDeal.postvaluation?.toFixed(2)}
        </Typography>
      </td>
      <td>
        <Typography color="text.primary" fontWeight="500" variant="body1">
          {rawDeal.percentacquired && `${rawDeal.percentacquired}%`}
        </Typography>
      </td>
      <td>
        <Typography color="text.primary" fontWeight="500" variant="body1">
          {rawDeal.vcround}
        </Typography>
      </td>
      <td>
        <Typography color="text.primary" fontWeight="500" variant="body1">
          {rawDeal.dealtype}
        </Typography>
      </td>
      <td>
        <Typography color="text.primary" fontWeight="500" variant="body1">
          {rawDeal.dealtype2}
        </Typography>
      </td>
      <td title={rawDeal.dealsynopsis || undefined}>
        <Typography
          color="text.primary"
          fontWeight="500"
          overflow="hidden"
          textOverflow="ellipsis"
          variant="body1"
          whiteSpace="nowrap"
        >
          {rawDeal.dealsynopsis}
        </Typography>
      </td>
    </tr>,
  );
};

export const DraggableTableRow = memo(Component);
